import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Section = styled.section`
  background: linear-gradient(180deg, #fffdf9 0%, #f6eee6 60%, #f5f1ec 100%);
  width: min(1180px, calc(100% - clamp(32px, 8vw, 96px)));
  padding: clamp(40px, 6vw, 72px) clamp(24px, 4vw, 56px);
  margin: clamp(24px, 3vw, 48px) auto;
  border-radius: var(--border-radius-2xl);
  box-shadow: 0 24px 48px rgba(43, 41, 39, 0.08);
  color: #302928;
  line-height: 1.8;

  h2 {
    font-size: clamp(2rem, 3vw, 2.8rem);
    color: var(--color-secondary);
    margin-bottom: var(--spacing-4);
  }
`;

const Paragraph = styled.p`
  max-width: 920px;
  margin-bottom: var(--spacing-4);
  font-size: clamp(1rem, 2vw, 1.15rem);
`;

const LinkGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-4);
  margin-top: var(--spacing-6);
`;

const LinkChip = styled(Link)`
  background: white;
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-2) var(--spacing-4);
  border: 1px solid rgba(0, 0, 0, 0.08);
  font-weight: 600;
  color: var(--color-secondary);
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    border-color: var(--color-secondary);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  }
`;

const links = [
  { to: '/produkter?kategori=doftljus-och-doftpinnar', label: 'Doft & ljus för hemmamys' },
  { to: '/produkter?kategori=dukning-och-servering', label: 'Dukning & servering' },
  { to: '/floristbloggen', label: 'Floristbloggen' },
  { to: '/kollektion/mysiga-hem', label: 'Kollektion Mysiga hem' }
];

const HomeSEOContent: React.FC = () => (
  <Section>
    <h2>En blomsterbutik i Kramfors med känsla för gåvor och inredning</h2>
    <Paragraph>
      Lillaflora är en lokal blomsterbutik i Kramfors som också driver en stark webshop för ljus &amp; doftljus,
      inredningsdetaljer och presenter. Våra florister hjälper dig att kombinera färg, form och doft så att du
      sitter kvar med ett varmt intryck, oavsett om du handlar i butiken eller beställer hem. Vi levererar hela
      vägen till Höga Kustens breddgrader och packar varje order som om den vore till familj eller en kär vän.
    </Paragraph>
    <Paragraph>
      Sortimentet innehåller noggrant utvalda inredningsdetaljer, lyxiga gåvor och hållbara favoriter från svenska
      leverantörer. Här finns allt från blockljus och doftpinnar till mjuka textilier och dukningstillbehör.
      Vår lokala service kombineras med snabb leverans, tydlig fraktinformation och trygg betalning för dig som vill
      handla med full transparens.
    </Paragraph>
    <Paragraph>
      För extra återkoppling och inspiration, läs våra guider i Floristbloggen eller bläddra i särskilda kollektioner
      som Mysiga hem. Vi bjuder på stylingtips, presentförslag och omsorgsfulla kombinationer så att du alltid hittar
      rätt produkt i sortimentet.
    </Paragraph>
    <LinkGrid>
      {links.map(link => (
        <LinkChip key={link.to} to={link.to}>
          {link.label}
        </LinkChip>
      ))}
    </LinkGrid>
  </Section>
);

export default HomeSEOContent;
